import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "promo",
  "use": "promo-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"promo\">\n  <path d=\"M12 0.625H6.6L0 7.225L5.4 12.625L12 6.025V0.625ZM9.42766 4.05342C8.95427 4.05342 8.57052 3.66966 8.57052 3.19628C8.57052 2.72289 8.95427 2.33913 9.42766 2.33913C9.90105 2.33913 10.2848 2.72289 10.2848 3.19628C10.2848 3.66966 9.90105 4.05342 9.42766 4.05342Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol